import { render, staticRenderFns } from "./RegisterFacilityModal.vue?vue&type=template&id=b36a1028&scoped=true&"
import script from "./RegisterFacilityModal.vue?vue&type=script&lang=js&"
export * from "./RegisterFacilityModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFacilityModal.vue?vue&type=style&index=0&id=b36a1028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36a1028",
  null
  
)

export default component.exports